import React from "react";
var __jsx = React.createElement;
//@ts-ignore

import { useTranslation } from "@i18n";
import { twMerge } from "tailwind-merge";
import { Icon } from "@syarahtech/ui";
import Tooltip from "@componentsShared/Tailwind/Tooltip/Tooltip";
import { useLang } from "@/common/Contexts/LanguageContext";
import { usePostDetails } from "@/common/Contexts/PostDetailsContext";
var CarColorVariation = function CarColorVariation(_ref) {
  var colors = _ref.colors,
    currentColorName = _ref.currentColorName,
    currentColorCode = _ref.currentColorCode;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _usePostDetails = usePostDetails(),
    helpers = _usePostDetails.helpers,
    actions = _usePostDetails.actions;
  var lang = useLang();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "pt-3 mt-3 font-bold"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-0.5 text-gray-text text-xs mb-3"
  }, /*#__PURE__*/React.createElement("span", null, t("لون السيارة:", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("span", null, currentColorName)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-end gap-3 en:justify-start",
    style: {
      direction: "ltr"
    }
  }, colors.map(function (color, idx) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      text: lang === 'ar' ? color.name_ar : color.name_en,
      key: idx
    }, /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: twMerge("w-8 h-8 rounded-full cursor-pointer hover:opacity-80 transition-opacity duration-200 p-px", currentColorCode === color.color_code ? "border-[2px] border-solid border-primary" : "border border-solid border-[#D6DFE9]"),
      onClick: function onClick() {
        return actions.navigateToColorVariation(color);
      },
      id: "color-variation-" + (idx + 1),
      "data-url": "/cardetail/".concat(color.post_id),
      "data-color-code": color === null || color === void 0 ? void 0 : color.color_code,
      "data-color-selected": currentColorCode === color.color_code
    }, /*#__PURE__*/React.createElement("div", {
      className: twMerge("w-full h-full rounded-full  flex items-center justify-center"),
      style: {
        backgroundColor: color.color_code
      }
    }, currentColorCode === color.color_code && /*#__PURE__*/React.createElement(Icon, {
      icon: "material-symbols--check-rounded",
      width: 5,
      height: 5,
      className: helpers !== null && helpers !== void 0 && helpers.isColorLight(color.color_code) ? "text-primary" : "text-white"
    }))));
  })), helpers.showImagesDisclaimer____WHY_THIS_NAME() && /*#__PURE__*/React.createElement("div", {
    className: "flex items-start gap-1 text-gray-slate text-xs mt-2 font-semibold"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--info-outline-rounded",
    width: 4,
    height: 4,
    className: "text-gray-slate mt-0.5"
  }), /*#__PURE__*/React.createElement("span", null, t("هل تحتاج إلى المزيد من الصور؟ يمكنك طلب صور إضافية عند حجز السيارة", {
    ns: "web_post_view"
  })))));
};
export default CarColorVariation;